import React from 'react';
import MyInfoView from '@fingo/lib/features/profile/views/MyInfoView';
import useProfileInfo from '../../../../features/profile/hooks/useProfileInfo';

const MyInfo = () => (
  <MyInfoView
    useProfileInfo={useProfileInfo}
    canEdit={false}
    stackSx={{ ml: 4, pb: 5 }}
  />
);

export default MyInfo;
